module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-02@2x-de7e337f116b1fd100ae013e3e5ca6d9.png";